import React, { Component, Dispatch } from 'react';
import { Log } from 'ng2-logger';
import Translator from '../../../../../core/i18n';
import { Formik, FormikContext, FormikProps } from 'formik';
import { getValidation } from '../../../../../models/validations/activity-exam-session-add-validation'; // change it
import { Common } from '../../../../../core/common';
import { IExamSessionData, IExamSessionList } from '../../../../../models/action/examSession';
import { IPreference } from '../../../../../models/action/profile';
import { connect } from 'react-redux';
import { IAction, IAppState } from '../../../../../models/action/core';
import { ExamScoringType } from '../../../../../models/enums/ExamScoringType';
import Moment from 'moment';
import { SelectNoneAsync } from '../../../../../components/input/select/main';
import { DatetimeFormik } from '../../../../../components/input/date-time/date-time-formik';
import Switch from 'react-switch';
import { Notification } from '../../../../../components/notification/main';
import Input from '../../../../../components/input/text/input-formik';
import * as Actions from '../../../../../store/actions/examSession';
import { IExamData } from '../../../../../models/action/exam';
import { ILessonPageClassInformation } from '../../../../../models/pages/coursePage';
import ICourseContentTermWeeks from '../../../../../models/components/course-content-termweeks';

const T = Translator.create();
const _logger = Log.create('add session modal tabpanel');
let _common: Common;

interface ISessionPropertiesProps {
    currentTab: string;
    dispatch?: any;
    userPreferences?: IPreference[];
    examSessionData?: IExamSessionData;
    updateActivityId?: string;
    examSessionId?: string;
    examId?: string;
    coursePageClassId?: string;
    coursePageActivityId?: string;
    formik: FormikContext<IExamData>;
    coursePageclassInformation?: ILessonPageClassInformation | null;
    courseContentTermWeeks?: ICourseContentTermWeeks[] | null;
    sessionList?: IExamSessionList[];
    setExamSessionId: (examSessionId: string) => void;
    publishDatas?:any;
}

class SessionProperties extends Component<ISessionPropertiesProps> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    getValidation = () => {
        if (
            this.props.coursePageclassInformation &&
            this.props.coursePageclassInformation.isWeekly === true &&
            this.props.coursePageclassInformation.startDate &&
            this.props.coursePageclassInformation.endDate
        ) {
            return getValidation({
                isProjectSubActivity: false,
                startDate: this.props.coursePageclassInformation.startDate,
                endDate: this.props.coursePageclassInformation.endDate,
                dateFormat: _common.findDateFormat(this.props.userPreferences!),
                termWeeks: this.props.courseContentTermWeeks,
                isUpdate: this.props.examSessionId ? true : false
            });
        } else {
            return getValidation({ isProjectSubActivity: false });
        }
    };

    onSubmit = (FormikValues: IExamSessionData) => {
        this.initSubmitValuesForApi(FormikValues);
        this.props.dispatch(Actions.ExamSessionAddAction(FormikValues, '', 'get', this.callBackFunction));
    };

    initSubmitValuesForApi(values: IExamSessionData) {
        const _formattedExamSessionBeginDate =
            values.examSessionBeginDate && values.examSessionBeginDateTime
                ? Moment(
                      values.examSessionBeginDate,
                      _common.findDateFormat(this.props.userPreferences) + ' ' + values.examSessionBeginDateTime,
                      window.appSettings.DefaultDateTimeFormat
                  )
                : '';
        values.examSessionBeginDateForApi = _formattedExamSessionBeginDate
            ? Moment(_formattedExamSessionBeginDate)
                  .set({
                      h: Moment(values.examSessionBeginDateTime, window.appSettings.DefaultDateTimeFormat).get('hour'),
                      m: Moment(values.examSessionBeginDateTime, window.appSettings.DefaultDateTimeFormat).get('minute')
                  })
                  .format(window.appSettings.DefaultDateFormatApi)
            : '';

        const _formattedExamSessionEndDate =
            values.examSessionEndDate && values.examSessionEndDateTime
                ? Moment(
                      values.examSessionEndDate,
                      _common.findDateFormat(this.props.userPreferences) + ' ' + values.examSessionEndDateTime,
                      window.appSettings.DefaultDateTimeFormat
                  )
                : '';
        values.examSessionEndDateForApi = _formattedExamSessionEndDate
            ? Moment(_formattedExamSessionEndDate)
                  .set({
                      h: Moment(values.examSessionEndDateTime, window.appSettings.DefaultDateTimeFormat).get('hour'),
                      m: Moment(values.examSessionEndDateTime, window.appSettings.DefaultDateTimeFormat).get('minute')
                  })
                  .format(window.appSettings.DefaultDateFormatApi)
            : '';
    }

    callBackFunction = (values: any) => {
        if (values) {
            this.getExamSessionList(values);
            this.props.setExamSessionId(values);
            if (this.props.examSessionId && this.props.examId) {
                this.props.dispatch(Actions.ExamSessionPublishDatas(this.props.examId, this.props.examSessionId, '', 'get'));
            }
        }
    };

    getExamSessionList = (examSessionId: string) => {
        if (this.props.coursePageActivityId && this.props.coursePageClassId && this.props.updateActivityId) {
            this.props.dispatch(
                Actions.ExamSessionListGetAction(
                    this.props.updateActivityId,
                    this.props.coursePageActivityId,
                    this.props.coursePageClassId,
                    '',
                    'get',
                    examSessionId
                )
            );
        }
    };

    validateAndSubmit = async (formik: FormikProps<IExamSessionData>) => {
        let isCompleted: boolean = true;

        const validations = await formik.validateForm().then((result: any) => result);
       
        Object.keys(validations).forEach((validationKey: string) => {
            Notification.setNotification(
                'error',
                T.t('r_validation_gen_' + validationKey) + ' - ' + validations[validationKey],
                'topRight'
            );

            isCompleted = false;
        });

        isCompleted = this.sessionListDateControl(formik.values);

        if (isCompleted) {
            formik.submitForm();
        }
    };

    sessionListDateControl = (formik: IExamSessionData): boolean => {
        let isValid = true;
        const dateFormat = _common.findDateFormat(this.props.userPreferences!);
        const BreakException = {};

        if (formik.examSessionBeginDate && formik.examSessionBeginDateTime && formik.examSessionEndDate && formik.examSessionEndDateTime) {
            const selectedDateFormat = dateFormat ? dateFormat : window.appSettings.DefaultDateFormat;
            const _beginDate = Moment(formik.examSessionBeginDate + ' ' + formik.examSessionBeginDateTime, selectedDateFormat + ' HH:mm');
            const _endDate = Moment(formik.examSessionEndDate + ' ' + formik.examSessionEndDateTime, selectedDateFormat + ' HH:mm');

            if (this.props.sessionList && this.props.sessionList.length) {
                const _sessionList = this.props.examSessionId
                    ? this.props.sessionList.filter(s => s.examSessionId !== this.props.examSessionId)
                    : this.props.sessionList;

                try {
                    _sessionList.forEach(session => {
                        const sessionBeginDate = Moment(session.beginDate.toString()).format(selectedDateFormat).toString();
                        const sessionBeginDateTime = Moment(session.beginDate.toString()).format(window.appSettings.DefaultDateTimeFormat).toString();

                        const sessionEndDate = Moment(session.endDate.toString()).format(selectedDateFormat).toString();
                        const sessionEndDateTime = Moment(session.endDate.toString()).format(window.appSettings.DefaultDateTimeFormat).toString();

                        const _sessionBeginDate = Moment(sessionBeginDate + ' ' + sessionBeginDateTime, selectedDateFormat + ' HH:mm');
                        const _sessionEndDate = Moment(sessionEndDate + ' ' + sessionEndDateTime, selectedDateFormat + ' HH:mm');

                        if (
                            (_beginDate >= _sessionBeginDate && _beginDate <= _sessionEndDate) ||
                            (_endDate >= _sessionBeginDate && _endDate <= _sessionEndDate) ||
                            (_sessionBeginDate >= _beginDate && _sessionBeginDate <= _endDate)
                        ) {
                            Notification.setNotification(
                                'error',
                                T.t('r_gen_exam_session_conflict_date'),
                                'topRight'
                            );

                            throw BreakException;
                        }
                    });
                } catch (e) {
                    if (e === BreakException) isValid = false;
                }
            }
        }

        return isValid;
    };

    public componentDidMount() {
        this.getSessionDatas();
    }

    getSessionDatas = () => {
        if (this.props.examSessionId && this.props.coursePageClassId && this.props.coursePageActivityId) {
            this.props.dispatch(
                Actions.ExamSessionGetUpdate(
                    this.props.examSessionId,
                    this.props.coursePageActivityId,
                    this.props.coursePageClassId,
                    '',
                    'get'
                )
            );
        }
    }

    public componentDidUpdate(prevProps: ISessionPropertiesProps) {
        if (this.props.examSessionId !== prevProps.examSessionId) {
            this.getSessionDatas();
        }
    }

    public render() {
        const userDateFormat: string = _common.findDateFormat(this.props.userPreferences!);

        const initialFormValues: IExamSessionData = {
            ...this.props.examSessionData!,
            dateFormat: userDateFormat,
            examSessionEndDate:
                this.props.examSessionData && this.props.examSessionData.examSessionEndDate
                    ? Moment(this.props.examSessionData.examSessionEndDate.toString())
                          .format(userDateFormat)
                          .toString()
                    : '',
            examSessionEndDateTime:
                this.props.examSessionData && this.props.examSessionData.examSessionEndDate
                    ? Moment(this.props.examSessionData.examSessionEndDate.toString())
                          .format(window.appSettings.DefaultDateTimeFormat)
                          .toString()
                    : '',
            examSessionBeginDate:
                this.props.examSessionData && this.props.examSessionData.examSessionBeginDate
                    ? Moment(this.props.examSessionData.examSessionBeginDate.toString())
                          .format(userDateFormat)
                          .toString()
                    : '',
            examSessionBeginDateTime:
                this.props.examSessionData && this.props.examSessionData.examSessionBeginDate
                    ? Moment(this.props.examSessionData.examSessionBeginDate.toString())
                          .format(window.appSettings.DefaultDateTimeFormat)
                          .toString()
                    : '',
            examId: this.props.updateActivityId ? this.props.updateActivityId : '',
            examSessionId: this.props.examSessionData ? this.props.examSessionData.examSessionId : '',
            dateCriteria: this.props.formik && this.props.formik.values ? this.props.formik.values.dateCriteria : undefined,
            dateRange: this.props.formik && this.props.formik.values ? this.props.formik.values.dateRange : undefined
        };

        const scoringType = [
            { value: ExamScoringType.Average, label: T.t('r_exam_scoring_type_Average') },
            { value: ExamScoringType.FirstAttempt, label: T.t('r_exam_scoring_type_FirstAttempt') },
            { value: ExamScoringType.Highest, label: T.t('r_exam_scoring_type_Highest') },
            { value: ExamScoringType.LastAttempt, label: T.t('r_exam_scoring_type_LastAttempt') },
            { value: ExamScoringType.Lowest, label: T.t('r_exam_scoring_type_Lowest') }
        ];

        return (
            <div
                className={'tab-pane fade' + (this.props.currentTab === '_sessionProperties' ? ' show active' : '')}
                style={{ width: '100%' }}
                role="tabpanel"
                aria-labelledby="all-users-tab"
            >
                <div className="container">
                            {((this.props.examSessionId && initialFormValues.examSessionId) || !this.props.examSessionId) && (
                                <Formik validationSchema={this.getValidation} initialValues={initialFormValues} onSubmit={this.onSubmit}>
                                    {formik => {
                                        return (
                                            <form onSubmit={formik.handleSubmit} role="form">
                                                <div className="row align-items-baseline">
                                                    <div className=" col-12 align-items-baseline custom-padding">
                                                        <h5 className="alms-h5">{T.t('r_add_exam_scoring_type')}</h5>
                                                        <SelectNoneAsync
                                                            isMulti={false}
                                                            name={'examScoringType'}
                                                            touched={formik.touched.examScoringType}
                                                            errors={formik.errors.examScoringType}
                                                            setFieldValue={formik.setFieldValue}
                                                            setOptions={scoringType}
                                                            // tslint:disable-next-line:jsx-no-lambda
                                                            onChange={(e: any) =>
                                                                formik.setFieldValue('examScoringType', e ? e.value : null)
                                                            }
                                                            isTouched={formik.setFieldTouched}
                                                            placeHolder={T.t('r_add_exam_select_scoring_type')}
                                                            setSelectValue={this.props.examSessionId ? [formik.values.examScoringType] : [0]}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row align-items-baseline">
                                                    <div className="col-12 align-items-baseline session_margin">
                                                        <h5 style={{marginTop:'8px'}} className="alms-h5">{T.t('r_session_name')}</h5>
                                                        <Input
                                                            type={'text'}
                                                            name={'name'}
                                                            placeHolder={T.t('r_write_name_activity')}
                                                            formik={formik}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className=" col-12 align-items-baseline mb-0">
                                                        <h5 className="alms-h5">{T.t('r_add_exam_session_begin_date')}</h5>
                                                        <div className="session_margin" style={{ width: '48%', float: 'left' }}>
                                                            <DatetimeFormik
                                                                name={'examSessionBeginDate'}
                                                                dateFormat={userDateFormat}
                                                                formik={formik}
                                                                placeHolder={T.t('r_datetime_picker_date')}
                                                                datePickerId={'examSessionBeginDate'}
                                                                mode="single"
                                                                isTouchedOnDidMount={this.props.examSessionId ? true : false}
                                                                static={true}
                                                            />
                                                        </div>
                                                        <div className="session_margin" style={{ width: '48%', float: 'right' }}>
                                                            <DatetimeFormik
                                                                name={'examSessionBeginDateTime'}
                                                                formik={formik}
                                                                datePickerId={'examSessionBeginDateTime'}
                                                                placeHolder={T.t('r_time')}
                                                                mode="time"
                                                                time24Hr={true}
                                                                static={true}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className=" col-12 align-items-baseline">
                                                        
                                                    <h5 className="alms-h5">{T.t('r_add_exam_session_end_date')}</h5>
                                                        <div className="session_margin" style={{ width: '48%', float: 'left' }}>
                                                            <DatetimeFormik
                                                                name={'examSessionEndDate'}
                                                                dateFormat={userDateFormat}
                                                                formik={formik}
                                                                placeHolder={T.t('r_datetime_picker_date')}
                                                                datePickerId={'examSessionEndDate'}
                                                                mode="single"
                                                                isTouchedOnDidMount={this.props.examSessionId ? true : false}
                                                                static={true}
                                                            />
                                                        </div>
                                                        <div className="session_margin" style={{ width: '48%', float: 'right' }}>
                                                            <DatetimeFormik
                                                                name={'examSessionEndDateTime'}
                                                                formik={formik}
                                                                datePickerId={'examSessionEndDateTime'}
                                                                placeHolder={T.t('r_time')}
                                                                mode="time"
                                                                time24Hr={true}
                                                                flatPickrClass={'date-picker-width'}
                                                                static={true}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className=" col-12 align-items-baseline">
                                                    <h5 className="alms-h5">{T.t('r_add_exam_auto_enroll')}</h5>
                                                        <label className="switch" style={{ marginTop: 4 }}>
                                                            <Switch
                                                                id={'check-autoEnroll'}
                                                                name={'autoEnroll'}
                                                                // tslint:disable-next-line:jsx-no-lambda
                                                                onChange={(e: any) => formik.setFieldValue('autoEnroll', e)}
                                                                checked={formik.values.autoEnroll}
                                                                defaultChecked={true}
                                                                onColor="#86d3ff"
                                                                onHandleColor="#28a745"
                                                                handleDiameter={18}
                                                                uncheckedIcon={false}
                                                                checkedIcon={false}
                                                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                                height={20}
                                                                width={38}
                                                                className="react-switch"
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="row align-items-baseline justify-content-end mr-2 mt-4">
                                                    <button
                                                        type="button"
                                                        className="px-4 category-tag-square tag-green"
                                                        // tslint:disable-next-line:jsx-no-lambda
                                                        onClick={() => this.validateAndSubmit(formik)}
                                                    >
                                                        {T.t('r_save_button')}
                                                        {/*<i className="material-icons small ml-2" style={{ fontSize: 24 }}>
                                                            done
                                                        </i>*/}
                                                    </button>
                                                </div>
                                            </form>
                                        );
                                    }}
                                </Formik>
                            )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ISessionPropertiesProps): ISessionPropertiesProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: ISessionPropertiesProps = Object.assign({}, ownProps, {
        userPreferences: state.profile.userPreferences.preferences,
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        examSessionData: state.examSession.examSessionData,
        coursePageclassInformation: state.coursePage.coursePageclassInformation,
        courseContentTermWeeks: state.coursePage.courseContentTermWeeks,
        sessionList: state.examSession.sessionList,
        publishDatas: state.examSession.publishDatas
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return (
        next.examSession.examSessionData === prev.examSession.examSessionData &&
        next.profile.userPreferences === prev.profile.userPreferences &&
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.coursePage.coursePageclassInformation === prev.coursePage.coursePageclassInformation &&
        next.coursePage.courseContentTermWeeks === prev.coursePage.courseContentTermWeeks &&
        next.examSession.sessionList === prev.examSession.sessionList &&
        next.examSession.publishDatas === prev.examSession.publishDatas
    );
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CSessionProperties = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(SessionProperties);

export default CSessionProperties;
